import { createModuleBuilder } from '@evidentid/dashboard-commons/app';

import ConfirmFilterOverrideProcedure from '@/modules/entity-filtering/procedures/ConfirmFilterOverrideProcedure.vue';

export const entityFilteringModule = createModuleBuilder()
    .registerProcedures<{
    confirmFilterOverride: {};
}>({
        confirmFilterOverride: ConfirmFilterOverrideProcedure,
    })
    .end();
